import { Box, Skeleton, Typography } from '@mui/material';
import { getCaseSummary } from '../../api';
import { useDispatch, useSelector } from 'react-redux';
import React, { useEffect } from 'react'
import Markdown from 'markdown-to-jsx';

const ConversationSummary = ({ subDomain, ticketingSystem, ticketDetails, orgId, prismToken, userEmail }) => {
    const caseSummaryContent = useSelector((state) => state.summary.caseSummaryContent);
    const caseSummaryLoading = useSelector((state) => state.summary.caseSummaryLoading);
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(getCaseSummary(subDomain, ticketingSystem, ticketDetails, userEmail, orgId, prismToken))
    }, [subDomain, ticketingSystem, ticketDetails, userEmail, orgId, prismToken, dispatch])

    return (
        <Box sx={{ width: '100%', height: '100%', overflowY: 'auto', lineHeight: 1.5, p: 2 }}>
            {caseSummaryLoading
                ? Array.from({ length: 5 }).map((_, idx) => (
                    <Box key={idx} sx={{ mb: 3 }}>
                        <Skeleton variant="text" width="40%" height={30} />
                        <Skeleton variant="rectangular" width="100%" height={100} />
                    </Box>
                ))
                : Object.entries(caseSummaryContent).map(([key, value]) => {
                    const capitalizedKey = key.charAt(0).toUpperCase() + key.slice(1);
                    return (
                        <Box key={key} sx={{ mb: 3 }}>
                            <Typography variant="subtitle1" fontWeight={800}>
                                {capitalizedKey} :
                            </Typography>
                            <Markdown>{value}</Markdown>
                        </Box>
                    );
                })}
        </Box>
    )
}

export default ConversationSummary